<div class="gwc-mobile-menu-container">
  <button class="gwc-mobile-menu-toggle"
    (click)="toggleMenu()">
    <mat-icon>{{ isOpen() ? 'close' : 'menu' }}</mat-icon>
  </button>

  @if (isOpen()) {
    <div class="gwc-mobile-menu">
      <nav class="gwc-mobile-menu__nav">
        <a class="gwc-mobile-menu__item"
          [routerLink]="['/orders']"
          [class.gwc-mobile-menu__item--active]="router.url.startsWith('/orders') || router.url.startsWith('/order')"
          (click)="closeMenu()">
          <span class="gwc-mobile-menu__item-icon">
            <svg><use href="assets/svg/sidebar-icons.svg#icon-passport"></use></svg>
          </span>
          My Orders
        </a>
        <!-- TODO: To be uncommented -->
        <!-- <a class="gwc-mobile-menu__item"
          [routerLink]="['/profiles']"
          routerLinkActive="gwc-mobile-menu__item--active"
          (click)="closeMenu()">
          <span class="gwc-mobile-menu__item-icon">
            <svg><use href="assets/svg/sidebar-icons.svg#icon-user"></use></svg>
          </span>
          My Profiles
        </a> -->
        <!-- TODO: To be uncommented -->
        <!-- <a class="gwc-mobile-menu__item"
          [routerLink]="['/account']"
          routerLinkActive="gwc-mobile-menu__item--active"
          (click)="closeMenu()">
          <span class="gwc-mobile-menu__item-icon">
            <svg><use href="assets/svg/sidebar-icons.svg#icon-profile"></use></svg>
          </span>
          My Account
        </a> -->
        <a class="gwc-mobile-menu__item"
          [routerLink]="['/inbox']"
          routerLinkActive="gwc-mobile-menu__item--active"
          (click)="closeMenu()">
          <span class="gwc-mobile-menu__item-icon">
            <svg><use href="assets/svg/sidebar-icons.svg#icon-message"></use></svg>
          </span>
          Message Center
        </a>
      </nav>
    </div>
  }
</div>
